<ng-container *ngIf="cacheManagerPageAccess">
<div class="container-fluid p-4">
  <h2 class="mb-4 text-center">🧠 Cache Manager</h2>

  <div class="row justify-content-center">
    <div class="col-md-10">
      <mat-card class="shadow-sm">
        <!-- Header with search and button -->
        <mat-card-header class="d-flex justify-content-between align-items-center flex-wrap">
          <mat-card-title class="mb-2 mb-md-0">
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search Cache Key</mat-label>
              <input matInput (keyup)="applyFilter($event)" placeholder="Type to filter..." />
            </mat-form-field>
          </mat-card-title>

         
<!-- Button container -->
  <div class="button-group">
    <button mat-raised-button color="primary" (click)="updateCache()">
      Update Selected Cache
    </button>
    <button mat-raised-button color="warn" (click)="deleteSelectedCache()">
      Delete Selected Cache
    </button>
  </div>


        </mat-card-header>

        <mat-card-content class="mt-3">
          <!-- Show table if cache keys exist -->
          <div *ngIf="cacheKeys && cacheKeys.length > 0; else noKeys">
            <div class="scrollable-table-container">
              <!-- Added [matSortActive] and [matSortDirection] -->
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                [matSortActive]="'lastModified'"
                [matSortDirection]="'desc'"
                class="mat-elevation-z1 w-100"
              >

                <!-- Cache Key Column -->
                <ng-container matColumnDef="key">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="d-flex align-items-center">
                      <mat-checkbox class="me-2 all-checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()"></mat-checkbox>
                      Cache Key
                    </div>
                  </th>
                  <td mat-cell *matCellDef="let item">
                    <div class="d-flex align-items-center">
                      <mat-checkbox [(ngModel)]="selectedKeys[item.key]" class="me-2"></mat-checkbox>
                      {{ item.key ? (item.key.charAt(0).toUpperCase() + item.key.slice(1)) : 'N/A' }}
                    </div>
                  </td>
                </ng-container>

                <!-- Size Column -->
                <ng-container matColumnDef="size">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Size </th>
                  <td mat-cell *matCellDef="let item"> {{ item.size }} </td>
                </ng-container>

                <!-- Last Modified Column -->
                <ng-container matColumnDef="lastModified">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Modified </th>
                  <td mat-cell *matCellDef="let item">
                    {{ item.lastModified ? (item.lastModified | date:'medium') : 'N/A' }}
                  </td>
                </ng-container>

                <!-- Header and Row Definitions -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>

          <!-- No Cache Keys Message -->
          <ng-template #noKeys>
            <div class="text-center text-muted mt-4">
              <p>No cache key found.</p>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<!-- Loader -->
<div *ngIf="loading" class="portfolio-totalApp-loader-margin">
  <app-loader class="loader-inside-card"></app-loader>
</div>
</ng-container>



<ng-container *ngIf="!cacheManagerPageAccess">
  <div class="unauthorized-container">
      <div>
        <div class="errorTitle-search"> Unauthorized to view this page. Please contact Techops team.</div>
      </div>
  </div>
</ng-container>
